import { create } from 'zustand'
import { z } from 'zod/v4'
import { CardStatus as PlatformCardStatus } from '@acre-rewards/lib'
import { PaymentCardStatus as LegacyCardStatus } from '@api/highnote/graphql'

export const LoadedCardStatus = z.union([PlatformCardStatus, z.enum(LegacyCardStatus)])

export const CARD_STATUS_LOADING = Symbol('CARD_STATUS_LOADING')

type CombinedCardStatus =
  | z.infer<typeof LoadedCardStatus>
  | typeof CARD_STATUS_LOADING
  | { error: unknown }

export const FrozenCardStatus = z.enum([
  LegacyCardStatus.Suspended,
  PlatformCardStatus.enum.inactive,
] as const satisfies CombinedCardStatus[])

export const useCombinedCardStatusStore = create<{
  status: CombinedCardStatus
  setStatus: (status: CombinedCardStatus) => void
}>((set) => ({
  status: CARD_STATUS_LOADING,
  setStatus: (status) => set({ status }),
}))
